import { call, put, select } from 'redux-saga/effects';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import {
  setDefaultAccountError,
  setOrganizationDetails,
  setPaymentSources,
} from '../../../effects/organization';

import AnalyticsService from '../../../../services/analytics.service';
import AnalyticsEvents from '../../../../services/analytics.constants';

export default function* setDefaultAccount({ id, isNewAccount = false }) {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA3
  }/${organizationId}/billing/payment-sources/${id}`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.PUT,
      body: {},
    });
    let hasError = false;
    if (success) {
      fireAnalyticsEvents({ id, isNewAccount });
      yield put(setDefaultAccountError(false));
      window.optimizely = window.optimizely || [];
      window.optimizely.push({
        type: 'event',
        eventName: 'creditCardAdded',
      });
      const { paymentSources, orgType } = result;
      yield put(setPaymentSources(paymentSources));
      yield put(setOrganizationDetails({ orgType }));
    }
    if (error) {
      hasError = true;
      console.error(
        `Collect payment method error: ${JSON.stringify({
          result,
          error,
        })}. Organization ID: ${organizationId}`,
      );
    }
    yield put(setDefaultAccountError(hasError));
  } catch (e) {
    console.error(
      `Collect payment method error: ${JSON.stringify({
        exception: e,
      })}. Organization ID: ${organizationId}`,
    );
    yield put(setDefaultAccountError(true));
  }
}

const fireAnalyticsEvents = ({ id, isNewAccount }) => {
  if (!id) {
    return;
  }
  if (isNewAccount) {
    AnalyticsService.track(AnalyticsEvents.PaymentAdded, {
      paymentId: id,
    });
  }
  AnalyticsService.track(AnalyticsEvents.PaymentSetAsDefault, {
    paymentId: id,
  });
};
